import Overlay from './code/Scripts/components/overlay.vue';

export default {
  components: {
    Overlay,
  },
};
